export default "__VITE_ASSET__1201514c__"